var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapse = function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 9.258c-.297 0-.547.14-.844.375L.383 13.89a.98.98 0 0 0-.367.773c0 .61.5 1.055 1.054 1.055.258 0 .524-.11.774-.305L6.5 11.672l4.664 3.742c.25.195.508.305.774.305.546 0 1.046-.446 1.046-1.055 0-.32-.14-.586-.367-.773L7.352 9.633c-.297-.235-.547-.375-.852-.375M6.5 7.313c.305 0 .555-.133.852-.375l5.265-4.25a1 1 0 0 0 .367-.774c0-.617-.5-1.055-1.046-1.055q-.399 0-.774.305L6.5 4.898 1.844 1.164C1.594.961 1.328.86 1.07.86A1.05 1.05 0 0 0 .016 1.914c0 .313.14.586.367.774l5.273 4.25c.297.242.547.375.844.375"
  })));
};
export default SvgCollapse;